// extracted by mini-css-extract-plugin
var _1 = "K55Rc";
var _2 = "JMT0w";
var _3 = "r9T2y";
export { _1 as "base", _2 as "label", _3 as "separator" }
